import React, { useState } from "react";
import ContactUsModal from "../ContactUsModal/contactUsModal";

/**
 * Same real ContactUsModal (open/setOpen state) the old ContactUs.tsx used -- only the
 * surrounding visual card changed, no submission logic touched.
 */
const PricingContactCTA: React.FC = () => {
  const [open, setOpen] = useState(false);

  return (
    <section className="pp-contact">
      <div className="pp-contact__card">
        <div className="pp-contact__glow" />
        <div className="pp-contact__content">
          <p className="pp-contact__eyebrow">Still have a query?</p>
          <h2 className="pp-contact__heading">
            <span className="lr-text-gradient">We&apos;d love to hear from you</span>
          </h2>
          <p className="pp-contact__lede">
            Questions about billing, features, or which plan is right for your studio? Reach
            out — we usually reply within a business day.
          </p>
          <button type="button" className="pp-contact__btn" onClick={() => setOpen(true)}>
            Contact us
            <span aria-hidden="true">→</span>
          </button>
        </div>
      </div>

      <ContactUsModal open={open} setOpen={setOpen} />
    </section>
  );
};

export default PricingContactCTA;
